import { render, staticRenderFns } from "./ClaimDevice.vue?vue&type=template&id=60b6e8e9&scoped=true&"
import script from "./ClaimDevice.vue?vue&type=script&lang=js&"
export * from "./ClaimDevice.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDevice.vue?vue&type=style&index=0&id=60b6e8e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6e8e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b6e8e9')) {
      api.createRecord('60b6e8e9', component.options)
    } else {
      api.reload('60b6e8e9', component.options)
    }
    module.hot.accept("./ClaimDevice.vue?vue&type=template&id=60b6e8e9&scoped=true&", function () {
      api.rerender('60b6e8e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/ClaimDevice.vue"
export default component.exports